<template>
  <v-container class="pa-50">
    <v-row>
      <v-col>
        <template>
          <v-data-table
            v-for="(item, index) in allProjectTypeNames"
            :key="`${item}`"
            :items="facilities(item)"
            :headers="headers(item)"
            :items-per-page="itemsPerPage(item, index)"
            :hide-default-footer="hideDefaultFooter(item)"
            :search="search"
            :sort-by.sync="sortBy"
            v-show="showHide(item)"
            @current-items="hideDistrictColumn"
            @click:row="selectFacilityItem"
            class="listClass"
            dense
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title class="headline">{{ item }}</v-toolbar-title>
              </v-toolbar>
            </template>
            <template v-slot:header.status></template>
            <template v-slot:header.facilityName v-if="isMobile"></template>
            <template v-slot:header.state v-if="isMobile"></template>
            <template v-slot:item.status v-if="!isMobile"></template>
            <template
              v-slot:item.facilityName="{ item }"
              v-on="selectFacility(item.facilityName)"
            >
              <span class="title facility-list-name">{{
                item.facilityName
              }}</span>
              <br v-if="!isMobile" />
              <span
                class="caption font-weight-light"
                v-if="item.status != 'Operational' && !isMobile"
                color="#666666"
                >{{ item.status }}</span
              >
            </template>

            <template
              v-slot:item.image="{ item }"
              v-on="selectFacility(item.facilityName)"
            >
              <v-img
                v-if="item.image"
                class="table-image"
                :src="item.image"
                :alt="item.facilityName"
              >
                <template v-slot:placeholder>
                  <v-skeleton-loader type="image" tile></v-skeleton-loader>
                </template>
              </v-img>
            </template>

            <template v-slot:item.state="{ item }">{{
              item.state | stateAbbr
            }}</template>

            <template v-slot:header.district v-if="hideDistrict"></template>
            <template v-slot:item.district v-if="hideDistrict"></template>

            <template v-slot:no-data>No {{ item }} Data</template>
          </v-data-table>
        </template>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
const vueName = 'ListView';
import listConfig from '@/config/listConfig';
import stateAbbrHelper from '@/helpers/StateAbbrHelper';

import { mapGetters, mapActions } from 'vuex';

export default {
  name: vueName,
  data() {
    return {
      energyTypes: listConfig.energyTypes,
      energyTypesMobile: listConfig.energyTypesMobile,
      sortBy: listConfig.sortBy,
      mobileHeaders: listConfig.mobileHeaders,
      hideDistrict: false,
      listClass: 'flat elevation-1 mb-4 mb-lg-8'
    };
  },
  mounted() {
    this.sMobile ? (this.listClass = '') : null;
  },
  computed: {
    ...mapGetters({
      filterStatus: 'filterData/mapFilterStatus',
      statusValues: 'filterData/statusValues',
      mapFilterEnergy: 'filterData/mapFilterEnergy',
      allProjects: 'tableData/allProjects',
      allCanadaProjects: 'tableData/allCanadaProjects',
      allUSProjects: 'tableData/allUSProjects',
      selectedItemType: 'mapTemplate/selectedItemType',
      selectedItemValue: 'mapTemplate/selectedItemValue',
      isMobile: 'mapTemplate/isMobile'
    }),
    allProjectTypeNames: function () {
      let allProjectTypeNames = [];
      for (let key in this.allProjects) {
        allProjectTypeNames.push(key);
      }
      return allProjectTypeNames;
    },
    search: function () {
      let searchVal;
      if (
        !this.filterStatus ||
        (this.filterStatus &&
          this.filterStatus.length == this.statusValues.length) ||
        this.filterStatus.length == this.statusValues.length + 1 // Accounts for NULL status
      ) {
        searchVal = null;
      } else if (!this.filterStatus.length) {
        searchVal = '$@#%^*'; // Hide data if nothing selected by searching for gibberish.
      } else if (this.filterStatus[0] == 'Operational') {
        searchVal = 'Operational';
      } else if (this.filterStatus[0] == 'Development/Construction') {
        searchVal = 'Development/Construction';
      } else {
        searchVal = null;
      }
      return searchVal;
    }
  },
  methods: {
    ...mapActions({
      selectItem: 'mapTemplate/selectItem'
    }),
    selectFacilityItem: function (item) {
      this.selectItem({ value: item.facilityName, type: 'Facility' });
    },
    facilities: function (item) {
      let currentFacilities;
      let selectedType = this.selectedItemType;
      let selectedValue = this.selectedItemValue;

      if (selectedType == 'Country') {
        switch (selectedValue) {
          case 'Global':
            currentFacilities = this.allProjects[item];
            break;
          case 'USA':
            currentFacilities = this.allUSProjects[item];
            break;
          case 'Canada':
            currentFacilities = this.allCanadaProjects[item];
            break;
          default:
            currentFacilities = this.allProjects[item];
        }
      } else if (selectedType == 'Geography') {
        currentFacilities = this.allProjects[item].filter(
          (x) => x.state.toUpperCase() == selectedValue.toUpperCase()
        );
      } else if (selectedType === 'Facility') {
        let currentSelected;
        this.energyTypes.map((eType) =>
          !currentSelected
            ? (currentSelected = this.allProjects[eType.name].find(
                (x) =>
                  x.facilityName.toUpperCase() == selectedValue.toUpperCase()
              ))
            : null
        );
        if (currentSelected && currentSelected.state) {
          currentFacilities = this.allProjects[item].filter(
            (x) => x.state.toUpperCase() == currentSelected.state.toUpperCase()
          );
        } else {
          currentFacilities = this.allProjects[item];
        }
      }
      return currentFacilities;
    },
    headers: function (item) {
      let currentItem = this.energyTypes.find(
        (i) => i.name.trim() === item.trim()
      );
      if (this.isMobile) {
        currentItem = this.energyTypesMobile.find(
          (i) => i.name.trim() === item.trim()
        );
      }
      // if (this.isMobile) {
      //   currentItem.headers = currentItem.headers.filter((h) =>
      //     this.mobileHeaders.includes(h.value)
      //   );
      // }
      return currentItem.headers;
    },
    itemsPerPage: function (item) {
      let currentItem = this.energyTypes.find(
        (i) => i.name.trim() == item.trim()
      );
      if (currentItem.itemsPerPage) {
        return currentItem.itemsPerPage;
      } else {
        return 5;
      }
    },
    hideDefaultFooter(item) {
      let numItems = this.facilities(item).length;
      return numItems < this.itemsPerPage(item) ? true : false;
    },
    showHide(item) {
      let filteredItem = item; //== 'Other' ? '<Null>' : item;
      return (
        (this.facilities(item).length && !this.mapFilterEnergy) ||
        (this.facilities(item).length &&
          this.mapFilterEnergy.includes(filteredItem))
      );
    },
    filterItems(item, search, filter) {
      this.search = this.statusType;
      return item.filter((x) => x.status == search);
    },
    hideDistrictColumn(currentItems) {
      currentItems.forEach((x) => {
        if (x.country == 'Canada') {
          this.hideDistrict = true;
        } else {
          this.hideDistrict = false;
        }
      });
    }
  },
  filters: {
    stateAbbr: function (item) {
      return stateAbbrHelper.stateAbbr(item);
    }
  }
};
</script>

<style lang="scss">
.table-image {
  max-width: 150px;
  max-height: 100px;
  margin: 5px;
}
.v-data-table {
  .v-data-table-header {
    background-color: $ne-blue;
    color: $ne-lightgray;
    th.sortable,
    th.sortable.active,
    .v-data-table-header__icon {
      color: $ne-lightgray !important;
    }
  }
  td:first-child {
    padding-left: 0;
    padding-right: 0;
  }
  // hide last column (STATUS) completely - Needed for filtering to work.
  th:last-child,
  td:last-child {
    width: 0;
    margin: 0;
    padding: 0;
  }
  .facility-list-name {
    color: #007db6;
  }
}
.v-data-table__mobile-row th:last-child,
td:last-child {
  width: auto !important;
  //border-bottom: thin solid #007db6 !important;
  padding-left: 16px !important;
  padding-right: 16px !important;
}
.v-data-footer {
  padding-left: 4px !important;
  margin-right: 1px !important;
}
.v-data-footer__select {
  margin-right: 1px !important;
}
</style>
